import React from "react";
import { ArrowRightGray, AttentionIcon, CompletedStep, CurrentStep, UnselectedStep } from "../../common/ProjectIcons";

type RouteProgressStepProps = {
    stepLabel: string;
    status: 'completed' | 'in-progress' | 'upcoming' | 'attention';
    finalStep: boolean;
}

const RouteProgressStep = ({
    stepLabel,
    status,
    finalStep
}: RouteProgressStepProps) => {

    const getStepIcon = () => {
        switch (status) {
            case 'attention':
                return <AttentionIcon />
            case 'completed':
                return <CompletedStep />;
            case 'in-progress':
                return <CurrentStep />;
            case 'upcoming':
            default:
                return <UnselectedStep />;
        }
    };

    const getLabelClassName = () => {
        return status === 'in-progress' ? 'text-brand-accent-green font-semibold' : '';
    };

    return (
        <div className="flex items-center transition-colors duration-300">
            {/* The tint wraps the step itself; the separator arrow stays outside
                it, so the pills read as discrete steps with gaps between them. */}
            <span className="flex items-center bg-teal-t10 rounded-lg py-2 px-3">
                <span className="mr-1.5 mb-1">{getStepIcon()}</span>
                <label className={`${getLabelClassName()} text-ui-text-secondary-text transition-colors duration-300`}>{stepLabel}</label>
            </span>
            {!finalStep && <span className="mx-3"><ArrowRightGray /></span>}
        </div>
    );
};

export default RouteProgressStep;